import React, {useEffect} from 'react'
import { connect } from 'react-redux'
import {fetchCartItems, clearCart} from '../actions/nCartAppActions'
import {bindActionCreators} from "redux";
import NCartProduct from "./NCartProduct";
import NCartLoadingProduct from "./NCartLoadingProduct";
import NShipping from "./NShipping";
import {NLoader} from './NLoader'
import NPayment from "./NPayment";


const NCart  = (props, attrs) => {

  const {fetchCartItems, clearCart} = props

  const checked_count = props.items.reduce((counter, obj) => {
      if (obj.checked) counter += 1;
      return counter;
      }, 0);

  const not_loaded = (props.items.length === 0 && props.num_items > 0) ? true : false;

  useEffect(() => {
      if (not_loaded){
          fetchCartItems();
      }
  },[props.num_items]);

  return (
      <div>
          <div className="nheader">
              {props.status === 'ERROR' ?
                  <div className="alert alert-danger">
                      <strong>Упс!</strong> Произошла ошибка. Для продолжения работы обновите страницу (Нажмите F5).
                  </div>
                  :
                  <h2>Корзина
                      ({checked_count === props.num_items ? props.num_items : `${checked_count}/${props.num_items}`})
                      <span className="ncart-delete-all" onClick={e => clearCart()}><i className="material-icons">delete</i></span>
                  </h2>
              }
          </div>
          { props.num_items === 0 ?
              <div className="nbody">
                  <div className="row ncart-empty">
                      <h2> Ваша корзина пуста</h2>
                  </div>
              </div>
          :
          <>
          <div className="nbody">

              <div className="ncart-detail-item">
                  { not_loaded ?
                      [...Array(props.num_items)].map((x, i) =>
                          <NCartLoadingProduct key={i}/>
                          )

                  :
                      props.items.map((item, key) => (
                            <NCartProduct item={item} key={item.id} index={key}/>
                          ))
                  }
                  { not_loaded &&<div className="ncart-loader"> <NLoader size="pl-size-l"/></div>}

              </div>
          </div>
          <div className="nheader total">
              {props.extra_rows.map((item, key) => (
                  item.amount > 0 &&
                <div className="row" key={key}>
                  <div className="col-sm-9 col-xs-6">
                      <h4 className="nshipping-title">{item.title}: </h4>
                  </div>
                  <div className="col-sm-3">
                      <div className="ncart-item-price">
                          <span className="price">{item.amount}&nbsp;&#8381;</span>
                      </div>
                  </div>
              </div>

              ))}
              <div className="row">
                  <div className="col-sm-9 col-xs-6">
                      <h2 className="price-title">Итог: </h2>
                  </div>
                  <div className="col-sm-3">
                      <div className="ncart-item-price">
                          {props.status === 'READY' ?
                              <span className="price">{props.total}&nbsp;&#8381;</span>
                              :
                              <NLoader/>
                          }
                      </div>
                  </div>
              </div>
           </div>

          <NShipping/>
          <NPayment/>
          </>
          }
      </div>
)}

const mapStateToProps = state => ({
    total: state.ncart.total,
    status: state.ncart.status,
    num_items: state.ncart.num_items,
    items: state.ncart.items,
    extra_rows: state.ncart.extra_rows
})

const mapDispatchToProps = dispatch => bindActionCreators({ fetchCartItems, clearCart}, dispatch);

export default connect(
  mapStateToProps, mapDispatchToProps
)(NCart)
